var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var getNavigationUrl = function getNavigationUrl(navigation) {
  return navigation && navigation.to ? navigation.to.pathname : 'UNKNOWN_URL';
};

export var RouteError = function () {
  function RouteError(navigation, status, message) {
    _classCallCheck(this, RouteError);

    this.navigation = navigation;
    this.status = typeof status === 'number' ? status : null;
    this.message = message;
  }

  _createClass(RouteError, [{
    key: 'toString',
    value: function toString() {
      return typeof this.message === 'string' ? this.message : 'Unknown RouteError';
    }
  }]);

  return RouteError;
}();
export var Unauthorized = function (_RouteError) {
  _inherits(Unauthorized, _RouteError);

  function Unauthorized(navigation) {
    _classCallCheck(this, Unauthorized);

    return _possibleConstructorReturn(this, (Unauthorized.__proto__ || Object.getPrototypeOf(Unauthorized)).call(this, navigation, 403, 'Unauthorized access to ' + getNavigationUrl(navigation)));
  }

  return Unauthorized;
}(RouteError);
export var NotFound = function (_RouteError2) {
  _inherits(NotFound, _RouteError2);

  function NotFound(navigation) {
    _classCallCheck(this, NotFound);

    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).call(this, navigation, 404, 'Not found ' + getNavigationUrl(navigation)));
  }

  return NotFound;
}(RouteError);
export var AuthenticationTimeout = function (_RouteError3) {
  _inherits(AuthenticationTimeout, _RouteError3);

  function AuthenticationTimeout(navigation) {
    _classCallCheck(this, AuthenticationTimeout);

    return _possibleConstructorReturn(this, (AuthenticationTimeout.__proto__ || Object.getPrototypeOf(AuthenticationTimeout)).call(this, navigation, 419, 'Authentication timeout'));
  }

  return AuthenticationTimeout;
}(RouteError);
export var BadRequest = function (_RouteError4) {
  _inherits(BadRequest, _RouteError4);

  function BadRequest(navigation) {
    _classCallCheck(this, BadRequest);

    return _possibleConstructorReturn(this, (BadRequest.__proto__ || Object.getPrototypeOf(BadRequest)).call(this, navigation, 400, 'Bad request to ' + getNavigationUrl(navigation)));
  }

  return BadRequest;
}(RouteError);